export default __webpack_public_path__ + "static/media/ic-geo-fence.3e9d23d8.svg";